const PATH_SEPARATOR = '/';

export function joinUrl(...paths: string[]) {
  return paths
    .map((path) => (path.endsWith(PATH_SEPARATOR) ? path.slice(0, -1) : path))
    .join(PATH_SEPARATOR);
}
